import '../_scss/structure.scss'
import "./_icons";
import './_header';

import { setCookie, toggleLoader } from './_functions';


document.getElementById('scroll__top').addEventListener('click', () => {
  if ('scrollBehavior' in document.documentElement.style) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } else {
    window.document.documentElement.scrollTop = 0;
  }
});

// Ставим CSS переменную высоты экрана
// Это фикс для корректного отображения высоты меню в мобильном виде
const currentVh = window.innerHeight * 0.01;
let tempVh = currentVh;

document.documentElement.style.setProperty('--vh', `${currentVh}px`);

document.addEventListener('scroll', () => {
  if (currentVh !== tempVh) {
    tempVh = currentVh;
    document.documentElement.style.setProperty('--vh', `${currentVh}px`);
  }
});

// Функциональность кнопки согласия с cookie policy
document.querySelector('.notification__cookies button')?.addEventListener('click', () => {
  setCookie('bizon_cookies_accepted', 'true', 365);
  document.querySelector('.notification__cookies').remove();
});


// Подписка на новости (в футере)

document.getElementById('mailchimp').addEventListener('submit', async event => {
  event.preventDefault();
  const $form = event.currentTarget;
  const $button = $form.querySelector('button[type=submit]');
  const submitUrl = '/mailchipadv/index/subscribe';

  toggleLoader($button, true);

  $form.querySelector('.text-success')?.remove();
  $form.querySelector('.text-danger')?.remove();

  const notification = document.createElement('div');

  const params = {
    EMAIL: $form.querySelector('input').value
  };

  try {
    const response = await fetch(submitUrl, {
      method: 'POST',
      mode: 'cors',
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html',
        'Content-Type': 'text/html; charset=UTF-8'
      },
      body: JSON.stringify(params)
    });

    const data = await response.text();

    if (Number(data) === 1) {
      notification.classList.add('text-success');
      notification.innerText = 'You have successfully subscribed!';
    } else {
      notification.classList.add('text-danger');
      notification.innerText = data;
    }

  } catch (error) {
    notification.classList.add('text-danger');
    notification.innerText = 'There was an error processing your request. Please, try again later.';

    console.log(error);
  } finally {
    toggleLoader($button, false);
    $form.prepend(notification);
  }
});
